import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import '../styles/aboutUs/AboutUs.min.css';

const AboutUs = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/sobre-nos');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className='section-separator'>
            <Container className='px-4 pb-3 text-center about-us-font'>
                <div className='pb-5 mb-5'>
                    <h2 className='display-5 fw-bold text-white about-us-font'>Sobre nós</h2>
                    <div className='col-lg-5 mx-auto'>
                        <p className='mb-4 about-us-text'>
                            A Youth 4 Change capacita jovens para serem líderes da transformação social através da educação não formal, mobilidades internacionais e participação ativa.
                        </p>
                        <div>
                            <button type='button' className='main-btn fw-bold' onClick={handleClick}>
                                Mais Informação
                            </button>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default AboutUs;
